import styleParams from '../PackagePicker/stylesParams';

export default {
  'page-header-color': styleParams.pageHeaderColor,
  'app-bg-color': styleParams.backgroundColor,
};
